export const USER_REGISTER_EVENT = 'USER_REGISTER_EVENT';
export const USER_PLAN_PUSHED_EVENT = 'USER_PLAN_PUSHED_EVENT';
export const BATCH_PURCHASED_EVENT = 'BATCH_PURCHASED_EVENT';
export const STORE_CONNECTION_SUCCESS_EVENT = 'STORE_CONNECTION_SUCCESS_EVENT';
export const ORDERS_COUNT = 'ORDERS_COUNT';
export const FIRST_LABEL_PURCHASED = 'FIRST_LABEL_PURCHASED';
export const FIRST_ORDER_ADDED = 'FIRST_ORDER_ADDED';
export const FIRST_STORE_CONNECTED = 'FIRST_STORE_CONNECTED';
export const CSV_IMPORT_SUCCESS = 'CSV_IMPORT_SUCCESS';
export const SET_FIRST_CARRIER = 'SET_FIRST_CARRIER';
export const SET_FIRST_CREDIT_CARD = 'SET_FIRST_CREDIT_CARD';
export const USER_SIGNED_IN = 'USER_SIGNED_IN';
export const CREATED_PACKAGE_TEMPLATE = 'CREATED_PACKAGE_TEMPLATE';
export const CREATED_FIRST_PACKAGE_TEMPLATE = 'CREATED_FIRST_PACKAGE_TEMPLATE';
export const BRANDING_UPDATED = 'BRANDING_UPDATED';
export const FIRST_AUTOMATION_CREATED = 'FIRST_AUTOMATION_CREATED';
export const AUTOMATION_CREATED = 'AUTOMATION_CREATED';
export const LABEL_SETTINGS_UPDATED = 'LABEL_SETTINGS_UPDATED';
export const COMPANY_UPDATED = 'COMPANY_UPDATED';
export const PRO_PLAN_TRIAL_STARTED = 'PRO_PLAN_TRIAL_STARTED';
